const productPage = document.querySelector('.template-product');
const openBtn = productPage.querySelector('#infoOpenBtn');
const stickyOpenBtn = productPage.querySelector('#StickyinfoOpenBtn');
const closeBtn = productPage.querySelector('#infoCloseBtn');
const imageContainer = productPage.querySelector('#infoImageContainer');

if(openBtn){
  openBtn.addEventListener('click', () => {
    imageContainer.style.display = 'flex';
    openBtn.style.display = 'none';
    closeBtn.style.display = 'block';
  });

  closeBtn.addEventListener('click', function() {
    imageContainer.style.display = 'none';
    closeBtn.style.display = 'none';
    openBtn.style.display = 'block';
  });

  stickyOpenBtn.addEventListener('click', () => {
    imageContainer.style.display = 'flex';
    openBtn.style.display = 'none';
    closeBtn.style.display = 'block';
  });
}